//getProfile api access
import { capi } from "..";

export const getProfile = () => {
    return capi.get('/v1/auth/get-profile');
}